import { Text } from "@twinkltech/web-ui";
import { useTranslation } from "react-i18next";

import { ExploreSubjectUnitCard } from "@/components/ExploreSubjectUnitCard/ExploreSubjectUnitCard";

import { useUrlFilters } from "@/hooks/useUrlFilters/useUrlFilters";

import { EXPLORE_SCHEME_NS } from "@/pages/ExploreScheme/ExploreScheme.i18n";

import type { ExploreSubjectSchemeUnit } from "@twinkltech/curriculum-architect-domain-hooks";

export const ExploreSubjectSchemeUnitList = ({
  units,
}: {
  units: ExploreSubjectSchemeUnit[];
}) => {
  const { t } = useTranslation(EXPLORE_SCHEME_NS);

  // Get filter values from URL
  const { filteredResources } = useUrlFilters({
    filterKeys: ["keyStages", "threads"],
    resources: units,
  });

  return (
    <div className="flex flex-col gap-3">
      <Text as="h2" className="text-neutral-700" variant={"base-normal"}>
        {t("unit-block.count", { count: filteredResources?.length })}
      </Text>
      <ul
        aria-label="Explore scheme unit list"
        className="flex flex-col gap-5 pb-12"
      >
        {filteredResources?.map((unit) => (
          <li key={unit.monolithUnitId}>
            <ExploreSubjectUnitCard unit={unit} />
          </li>
        ))}
      </ul>
    </div>
  );
};
